import {UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {PossibleRequest, TanstackQueryData} from '$constants/api-infos'

import useMyDataAgreementWebAppEnv from './my/useMyDataAgreementWebAppEnv'
import useApiQuery from './useApiQuery'

/**
 * [보험] 기기환경이 웹앱인 페이지 전용 useQuery
 *
 * @param queryOptions UseQueryOptions
 * @returns {UseQueryResult} ReturnType\<useQuery\>
 */
const useWebAppApiQuery = <Response, Request extends PossibleRequest>(
    queryOptions: UseQueryOptions<Response, AxiosError> & ReturnType<TanstackQueryData<Response, Request>['query']>,
) => {
    const enabled = useMyDataAgreementWebAppEnv()

    return useApiQuery({
        ...queryOptions,
        enabled: (queryOptions.enabled ?? true) && enabled,
    })
}

export default useWebAppApiQuery
